<template>
  <div class="card">    
    <div class="card-body ">
      <div class="mb-3">
      <div class="row">
        <div class="col-10">
          <div>
            <el-form  :model="filter" @submit.prevent="searchSubmit" >
              <div class="row">
                <div class="col-5">
                  <el-input
                    v-model="filter.search" 
                    placeholder="ค้นหาใบส่งสินค้า|ทะเบียน|ชื่อ-ที่อยู่ลูกค้า [Enter]"
                    clearable 
                    :prefix-icon="searchIcon"
                  />
                </div>
                
                <el-button hidden native-type="submit" icon="el-icon-search"></el-button>
                <div class="col-4">
                  <date-time-picker-with-option style="width: 100%"  v-model="filter.dateRange" @change="searchSubmit"></date-time-picker-with-option>
                </div>
                           
              </div>
            </el-form>

          </div>
        </div>
        <div class="d-flex flex-row col-2 justify-content-end">         
          <!-- <button class="btn btn-sm btn-primary" @click="openDeliveryModal" :disabled="selectedOrder&& (selectedOrder.delivery_method.trim() == 'pickup' || selectedOrder.isComplete)">
            <i class="fas fa-edit"></i>
             จัดรถ
          </button> -->
          <!-- &nbsp;&nbsp;
          <button class="btn btn-sm btn-dark-green" @click="openDeliveryModal">
            <i class="fas fa-check"></i>
             ยืนยันส่งสินค้า
          </button>-->
          <button class="btn btn-sm btn-success" @click="createBillingNote" v-if="status == 'success'">
            <i class="fas fa-plus"></i>
              เพิ่มวางบิลค่าส่ง
          </button>
        </div>
      </div> 
    </div>
        <!-- @row-click="onRowClickHandeler" -->
    <div class="d-flex flex-row col justify-content-center">
      <el-table
        :data="orders"
        @current-change="onRowSelectHandler"     
        @selection-change="handleSelectionChange"
        @row-dblclick="redirectToShipment2SDetail"   
        :height="windowHeight - 240"
        highlight-current-row
        show-summary
        :summary-method="summary"
      >
        <el-table-column
          v-if="status == 'success'"
          :selectable="selectableBill"
          type="selection"
          width="50"
          align="center"
        ></el-table-column> 
        <el-table-column
           v-else
          :selectable="selectable"
          type="selection"
          width="50"
          align="center"
        ></el-table-column>         
        <el-table-column
          :label="status == 'nondelivery'?'ใบส่งสินค้า':'ใบกำกับ/ใบส่งสินค้า'"
          prop="shipmentCode"
          width="150"
         >
          <template #default="scope">
            <p @click="redirectToShipment2SDetail" v-if="!scope.row.isConfirm" class="fw-bolder text-primary m-0" >{{scope.row.shipmentCode }}</p>
            <p @click="redirectToShipment2SDetail" v-else class="fw-bolder text-success m-0" >{{scope.row.invoiceCode }}</p>
            <span  @click="redirectToShipment2SDetail" v-if="scope.row.isConfirm"> {{scope.row.shipmentCode }}</span>
          </template>
        </el-table-column>           
        <el-table-column
          label="การจัดส่ง"
          prop="delivery_method"
          width="120"
        >
            <template  #default="scope">
              <span class="fw-bolder" v-if="scope.row.delivery_method.trim() == 'pickup'" >รับเอง</span>
              <span  class="fw-bolder" v-else >จัดส่ง </span> 
              <p  class="m-0" v-if="scope.row.partnerDeliveryDate"> {{ formatDateTimeFromISO(scope.row.partnerDeliveryDate) }}</p>
            </template>
        </el-table-column>   
        <el-table-column
          label="คำสั่งซื้อ"
          prop="uoRefNo"
          width="140"
          v-if="status == 'nondelivery'">
          <template #default="scope">
              <p @click="redirectToShipment2SDetail" class="fw-bolder m-0" >#{{scope.row.uoRefNo }}</p>
              <span  @click="redirectToShipment2SDetail" > {{scope.row.receive_code }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="ทะเบียน"
          width="110"
          v-if="status == 'nondelivery'">
          <template #default="scope">
              <span  v-if="!scope.row.isConfirm"  @click="openDeliveryModal(scope.row)"> 
                <span v-if="scope.row.delivery_method.trim() != 'pickup'">
                  {{scope.row.pnTruckCode}}
                </span>
                <span v-else>
                  {{scope.row.cusTruckCode}}
                </span> &nbsp;
                <i class="fas fa-edit text-primary"></i>                
              </span>
          </template>
        </el-table-column>     
        <!-- <el-table-column
          label="วันนัดรับสินค้า"
          prop="delivery_date"
          width="120">
          <template #default="scope">
            {{ formatDateFromISO(scope.row.delivery_date) }}
          </template>
        </el-table-column>         -->
        <el-table-column
          label="ลูกค้า"   
          prop="cusname">
        </el-table-column>
        <el-table-column
          label="ที่อยู่"
          prop="delivery_address"
          v-if="status == 'nondelivery'"
          width="130"
        >
        </el-table-column>
        <!-- <el-table-column
          label="หมายเหตุ"
          prop="remark">
        </el-table-column> -->
        <el-table-column
          label="นน.รวม"
          prop="total_weight"
          width="120"
          align="right">          
          <template #default="scope">
            {{ numberWithCommas(scope.row.total_weight, 2) }}
          </template>
        </el-table-column> 
          
        <el-table-column
          label="ราคาก่อน VAT"
          prop="total_price_no_vat"
          width="115"
          align="right"
          v-if="status == 'success'">          
          <template #default="scope">
            {{ numberWithCommas(scope.row.total_price_no_vat, 2) }}
          </template>
        </el-table-column>   
        <el-table-column
          prop="totalCost"
          label="ราคาทุน"
          align="right"
          v-if="status == 'success'"
        >
          <template v-slot="scope">                
            <span v-if="scope.row.totalCost>0">
              {{
              numberWithCommas(scope.row.totalCost, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>       
        <!-- <el-table-column
          label="สถานะ"
          align="center"
          width="200"
          v-if="status != 'nondelivery'">
        </el-table-column>  -->
        <el-table-column
          prop="compensionTotal"
          label="ค่าดำเนินการ"
          align="right"
          width="105"
          v-if="status == 'success'"
        >
          <template v-slot="scope">
            <span v-if="scope.row.compensionTotal>0">
              {{
              numberWithCommas(scope.row.compensionTotal, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>   
        <el-table-column
          prop="compensionVatBal"
          label="VAT 7% ค่าดำเนินการ"
          align="right"
          v-if="status == 'success'"
        >
          <template v-slot="scope">
            <span v-if="scope.row.compensionVatBal>0" >
              {{
              numberWithCommas(scope.row.compensionVatBal, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>   
        <el-table-column
          prop="compensionWHTax"
          label="ภาษีหัก ณ ที่จ่าย 3%"
          align="right"
          v-if="status == 'success'"
        >
          <template v-slot="scope">
            <span v-if="scope.row.compensionWHTax>0">
              {{
              numberWithCommas(scope.row.compensionWHTax, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>  
        <el-table-column
          prop="sumCompensionTotal"
          label="รวมค่าดำเนินการ"
          align="right"
          v-if="status == 'success'"
        >
          <template v-slot="scope">
            <span v-if="((scope.row.compensionTotal+scope.row.compensionVatBal)-scope.row.compensionWHTax)>0" class="text-primary">
              {{
              numberWithCommas((scope.row.compensionTotal+scope.row.compensionVatBal)-scope.row.compensionWHTax, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>          
        <el-table-column prop="billingNoteCode" label="ใบวางบิลค่าส่ง" width="120" v-if="status == 'success'">
          <template v-slot="scope">
            <span> {{scope.row.billingNoteCode }}</span>
          </template>
        </el-table-column>   
        <el-table-column
          prop="delivery_price"
          label="ค่าขนส่ง"
          align="right"
          v-if="status == 'success'"
        >
          <template v-slot="scope">
            <span v-if="scope.row.delivery_price>0" class="text-primary">
              {{
              numberWithCommas(scope.row.delivery_price, 2)
              }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>  
        <el-table-column
          label=""
          align="center"
           width="180"
       >
          <template  #default="scope">
            <div class="d-flex justify-content-center" v-if="scope.row.total_weight>0">       
              <!-- <button class="btn btn-sm btn-dark-green">
                <i class="fa fa-print" ></i>
                พิมพ์
              </button> -->
              <print-delivery-2-s-online
                class="btn btn-sm btn-primary"  
                :disabled="scope.row.isCancel"            
                :uoRefNo="scope.row.uoRefNo" :shipmentCode="scope.row.shipmentCode" :printNum="scope.row.printNum"
                @refresh="getShipment">
              </print-delivery-2-s-online>
              &nbsp;&nbsp;
              <PrintAIVoucherFromERP :disabled="scope.row.aiCode == null || scope.row.aiCode== ''" :printNum="scope.row.aiPrintNum"  class="btn btn-sm btn-green" @refresh="getShipment"  :uoRefNo="scope.row.uoRefNo" :aiCode="scope.row.aiCode" ></PrintAIVoucherFromERP>
              
              <button class="btn btn-sm btn-dark-green p-2" @click="ConfirmShipment(scope.row)" :disabled="scope.row.isConfirm || scope.row.isCancel || scope.row.printNum <1" v-if="status == 'nondelivery'">
                <span class="d-flex">
                  <i class="fas fa-check" style="color: #fff;"></i> <i class="fas fa-truck" style="color: #fff;"></i>
                </span>              
                <!-- ยืนยันส่ง -->
              </button>
              &nbsp;&nbsp;
              <button
                class="btn btn-sm btn-danger"
              @click="CancelShipmentData(scope.row)"
              :disabled="scope.row.isConfirm"
                v-if="status == 'nondelivery'"
              >
                <span class="d-flex">
                  <i class="fas fa-trash"></i>
                </span>
                <!-- ยกเลิกส่ง -->
              </button>
          </div>  
           
          </template>
        </el-table-column>        
        
      </el-table>
    </div>
    <div class="flex-row col justify-content-center mt-2">
     
        <button class="btn btn-sm btn-dark-green p-2" >        
          <i class="fas fa-check" style="color: #fff;"></i> <i class="fas fa-truck" style="color: #fff;"></i>              
          <!-- ยืนยันส่ง -->          
        </button> 
      
        <small class="font-green">
            ใช้สำหรับยืนยันส่งสินค้า
        </small>
    </div>      
    </div>
    <SetDeliveryDataModal ref="SetDeliveryDataModal" v-if="selectedOrder" :UORefNo="selectedOrder.uoRefNo" :Order="selectedOrder" @getOrderFn="getShipment"/>
  </div>
</template>

<script>
// import { reactive, ref } from "vue";
import ApiService from '../../core/services/ApiService';
import { numberWithCommas, formatDateFromISO, formatDateThDate,formatDateTimeFromISO } from "@/utils";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { DateTime } from 'luxon'
import OrderStatus from '../../components/status/OrderStatus.vue';
import DateTimePickerWithOption from '../../components/forms/DateTimePickerWithOption.vue';
import { Calendar, Search } from '@element-plus/icons'
import { validateRole, role } from "@/helpers/role"
import SetDeliveryDataModal from '../../components/modals/forms/SetDeliveryDataModal.vue';
import PrintDelivery2SOnline from '../../components/forms/PrintDelivery2SOnline.vue';
import PrintAIVoucherFromERP from '../../components/forms/PrintAIVoucherFromERP.vue';
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  components: {
    // OrderStatus,
    DateTimePickerWithOption,
    SetDeliveryDataModal,
    PrintDelivery2SOnline,
    PrintAIVoucherFromERP
  },
  props: {
    partnerCode: String,
    status:String
  },
  data() {
    return {     
      partner: {},
      windowHeight: window.innerHeight,
      orders: [],
      loading: false,
      selectedOrder: null,
      loadingHead: false,
      filter: {
        search: null,
        status: [],
        dateRange: []
      },
      searchIcon: Search,
      multipleSelection: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser
    },
    isAdmin() {
      return this.currentUser.role == "Admin"
    },
    uoRefNoSelected() {
        return this.multipleSelection.map(c => {
                return c.uoRefNo;
            }).join(',');
    },  
  },
  created() {
    
    if(this.$route.query.startDate) {
      this.filter.dateRange[0] = new Date(this.$route.query.startDate)
      this.filter.dateRange[1] = new Date(this.$route.query.endDate)
    }
    else {
      
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      
      this.filter.dateRange[0] = new Date(y, m, 1)
      this.filter.dateRange[1] = new Date(y, m + 1, 0)
    }
    if(window.localStorage.getItem('shipmentNDFilter' && this.status == 'nondelivery')){
      var tempND = JSON.parse(window.localStorage.getItem('shipmentNDFilter'));  
      tempND.dateRange[0]= new Date(tempND.dateRange[0]);
      tempND.dateRange[1]= new Date(tempND.dateRange[1]);  
      this.filter =tempND;
      window.localStorage.removeItem('shipmentNDFilter');  
    }

    if(window.localStorage.getItem('shipmentSFilter' && this.status == 'success')){
      var temp = JSON.parse(window.localStorage.getItem('shipmentSFilter'));  
      temp.dateRange[0]= new Date(temp.dateRange[0]);
      temp.dateRange[1]= new Date(temp.dateRange[1]);  
      this.filter =temp;
      window.localStorage.removeItem('shipmentSFilter');  
    }
   
    
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
        });
    })
    
    if(this.status == 'nondelivery'){
      setCurrentPageBreadcrumbs("รอยืนยันส่ง", [])
    }else{
      setCurrentPageBreadcrumbs("สำเร็จ", [])
    }
   
    
    if(this.partnerCode )
    {
      this.getPartner()
    }
    this.getShipment()
  },
  methods: {
    getPartner: async function() {
      const { data } = await ApiService.get("partners", this.partnerCode);
      this.partner = data
      setCurrentPageBreadcrumbs("รายการขาย" + this.partner.partnerName + " (" + this.partner.partnerCode + ")", ["รายงาน"])
    
    },
    getShipment() {
      this.loading = true;      
      this.selectedOrder = null

      let startDate
      let endDate
      // const status = this.status.find(s => s.name == this.filter.status)
      if(this.filter.dateRange ) {
        if(this.filter.dateRange[0] ) {
          // console.log(DateTime.fromJSDate (this.filter.dateRange[0]), this.filter.dateRange[0])
          startDate = DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd')
        }
        if(this.filter.dateRange[1] ) {
          endDate = DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd')
        }
      }
      let url = "orders/GetShipmentOrderFrom2SOnline"
      
      ApiService.query(
        url, 
        {
          params: {
            search: this.filter.search,
            startDate,
            endDate,
            menuStatus:this.status
          }
        })
        .then((res) => {
          this.orders = res.data
          // console.log(this.orders);
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
      
    },
    selectable(row, index) {
      // if(row.shipmentCode ){
      //   return false;
      // }
      return true;
    }, 
    selectableBill(row, index) {
      if(row.billingNoteCode || row.delivery_price==0){
        return false;
      }
      return true;
    }, 
    onRowSelectHandler(row) {
      this.selectedOrder = row
      //this. getDeliveryOrder(row.uoRefNo);
    },
    getDeliveryOrder(data) {
      this.isLoading = true;
      this.selectedOrder=data;
      let url = "orders/GetDeliveryOrder2SOnline"
      
      ApiService.query(
        url, 
        {
          params: {
            uoRefNo:data.uoRefNo
          }
        })
        .then((res) => {
          this.selectedOrder.truckID = res.data.truckID;
          this.selectedOrder.partnerDeliveryDate = res.data.partnerDeliveryDate;
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },   
    onRowClickHandler(row, column, event) {
      // this.$router.push({name: 'orderDetail', params: {orderCode: row.orderCode}})
      this.redirectToShipment2SDetail(row);
    },
    redirectToShipment2SDetail() { 
      if(this.status == 'nondelivery'){
        window.localStorage.setItem('shipmentNDFilter', JSON.stringify(this.filter));
      }else{
        window.localStorage.setItem('shipmentSFilter', JSON.stringify(this.filter));
      }
       
        this.$router.push({name: 'shipment2SDetail', params: {uoRefNo: this.selectedOrder.uoRefNo,status:this.status}})
    },
    searchSubmit() {
      this.getShipment();
      if(this.status == 'nondelivery'){
        window.localStorage.setItem('shipmentNDFilter', JSON.stringify(this.filter));
      }else{
        window.localStorage.setItem('shipmentSFilter', JSON.stringify(this.filter));
      }
    }, 
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 1) {
          sums[index] = data.length + ' รายการ';
        }


        const sumColumns = ['total_weight', 'total_sell_price','compensionTotal','delivery_price','compensionVatBal','compensionWHTax','sumCompensionTotal']
        if(sumColumns.includes(col.property)) {
          if(col.property==="sumCompensionTotal"){
            let sumCompensionTotal =  data.reduce(
                        (prev, curr) => {
                          console.log("prev",prev);
                          console.log("curr",curr);
                        return prev + ((curr.compensionTotal+curr.compensionVatBal)-curr.compensionWHTax)
                        },
                        0
                    )
                                    
            sums[index] = numberWithCommas(sumCompensionTotal,2); //+ " เส้น " ;
          }else{
            sums[index] = numberWithCommas(data.reduce(
              (prev, curr) => {
                return prev + ( curr.canceled ? 0 : curr[col.property] )
              },
              0
            ))
          }
         
        }


      })
      
        return sums;
    },
    openDeliveryModal(rowSelected){
      // this.selectedOrder=null;
      this.selectedOrder = rowSelected;
      if(!rowSelected){
        this.$message({
          type: "warning",
          message: "กรุณาเลือกอย่างน้อย 1 รายการ เพื่อบันทึกข้อมูลจัดส่ง",
        });  
        return;
      }
      setTimeout(() => {
          this.$refs.SetDeliveryDataModal.show();
      }, 500);
     
    },
    async ConfirmShipment(row) {
      const loader = this.$loading.show();
      try {
        var tempData;
          const { data } = await ApiService.post("Orders/ConfirmShipmentData", {
            uoRefNo:row.uoRefNo,
            // productSelected:this.productSelected
          });
          tempData = data;
          this.$swal("สำเร็จ", "ยืนยันส่งสินค้าแล้ว", "success");
          this.getShipment(row);
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถยืนยันส่งสินค้าได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      this.btnLoading = false;
      loader.hide();
    },     
    CancelShipmentData(row) {
      if(row.isComplete) return
      this.isLoading = true;
      
      this.$swal.fire({
        icon: 'question',
        title: 'ต้องการยกเลิกการส่งสินค้า?',
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "กลับ"
      })
      .then( result => {
        if(result.isConfirmed) {
          const loader = this.$loading.show();
          const params =  {
            uoRefNo:row.uoRefNo,
          }
          setTimeout(() => {
            ApiService.post("Orders/CancelShipmentData", params)
              .then((res) => {
                row.isCancel = true;
                this.$swal("สำเร็จ", "ยกเลิกรายการส่งสินค้าแล้ว", "success");
                this.searchSubmit();
              })
              .catch((err) => {
                this.$swal("เกิดข้อผิดพลาด", "", "error");
                if (err.resonse) {
                  console.log(err.resonse);
                }
              })
              .finally(() => {
                this.isLoading = false;
                loader.hide();
              });
          }, 500);
        }
      })
    },
    async createBillingNote(){
      // console.log(this.uoRefNoSelected);
      const loader = this.$loading.show();
      try {
        if(this.uoRefNoSelected){
          
          const { data } = await ApiService.post("compensation/AddBillingNote", {
            uoRefNoSelected: this.uoRefNoSelected
          });
          this.getShipment(); 
        }else{
            Swal.fire("", "กรุณาเลือกวางบิลอย่างน้อย 1 รายการ" , "warning"); 
        }
        
        
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถเพิ่มรายการวางบิลได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      loader.hide();
    },    
    formatDateThDate,
    numberWithCommas,
    formatDateFromISO,
    formatDateTimeFromISO,
  },
  
};
</script>
<style scoped>
.btn-green {
    color: #fff;
    background-color: #35a5b6;
    border-color: #117a8b;
}
.btn-dark-green {
    color: #fff;
    background-color: #066f8f;
}
.icon-green {
    color:  #117a8b;
}
.font-green {
    color:  #117a8b;
}
</style>